import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h1>Произошла ошибка.</h1>
          <div>{this.state.error.message}</div>
        </div>
      );
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
